// STYLES
import * as Style from "./EventDetailsStyle";

// LIBRARIES
import { useNavigate, useParams } from "react-router-dom";
// MISC

// ASSETS
import DeleteIcon from "assets/Icons/DeletedIcon.svg";
import EditIcon from "assets/Icons/EditIcon.svg";
// REDUX

// COMPONENTS

const EventDetails = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const navigate = useNavigate();
  let { eventId = "" } = useParams();
  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS
  const photo =
    "https://c4.wallpaperflare.com/wallpaper/38/841/126/nature-boat-wallpaper-preview.jpg";
  // eslint-disable-next-line
  const video = "https://www.youtube.com/watch?v=xNRJwmlRBNU";

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  const handleMedia = (
    type: string,
    src: string,
    width: string,
    height: string
  ) => {
    if (type === "video") {
      return (
        <iframe
          src="https://www.youtube.com/embed/zpOULjyy-n8?rel=0"
          title="YouTube video"
          width={width}
          height={height}
          style={{ borderRadius: "15px" }}
        />
      );
    } else if (type === "photo") {
      return (
        <Style.PhotoContainer
          height={height && height}
          width={width && width}
          src={src}
        />
      );
    }
  };

  return (
    <Style.Container>
      <Style.IconsContainer>
        <Style.EditIconContainer
          src={EditIcon}
          onClick={() => navigate(`/event-edit/${eventId}`)}
        />
        <Style.DeleteIconContainer src={DeleteIcon} />
      </Style.IconsContainer>
      <Style.ContentContainer>
        <Style.DescriptionContainer>
          <Style.TitleContainer>
            {" "}
            Nume eveniment lorem ipsum sit dolor
          </Style.TitleContainer>
          <Style.TextContainer>
            What is Lorem Ipsum? Lorem Ipsum is simply dummy text of the
            printing and typesetting industry. Lorem Ipsum has been the
            industry's standard dummy text ever since the 1500s, when an unknown
            printer took a galley of type and scrambled it to make a type
            specimen book. It has survived not only five centuries, but also the
            leap into electronic typesetting, remaining essentially unchanged.
            It was popularised in the 1960s with the release of Letraset sheets
            containing Lorem Ipsum passages, and more recently with desktop
            publishing software like Aldus PageMaker including versions of Lorem
            Ipsum. Why do we use it? It is a long established fact that a reader
            will be distracted by the readable content of a page when looking at
            its layout. The point of using Lorem Ipsum is that it has a
            more-or-less normal distribution of letters, as opposed to using
            'Content here, content here', making it look like readable English.
            Many desktop publishing packages and web page editors now use Lorem
            Ipsum as their default model text, and a search for 'lorem ipsum'
            will uncover many web sites still in their infancy. Various versions
            have evolved over the years, sometimes by accident, sometimes on
            purpose (injected humour and the like). Where does it come from?
            Contrary to popular belief, Lorem Ipsum is not simply random text.
            It has roots in a piece of classical Latin literature from 45 BC,
            making it over 2000 years old. Richard McClintock, a Latin professor
            at Hampden-Sydney College in Virginia, looked up one of the more
            obscure Latin words, consectetur, from a Lorem Ipsum passage, and
            going through the cites of the word in classical literature,
            discovered the undoubtable source. Lorem Ipsum comes from sections
            1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes
            of Good and Evil) by Cicero, written in 45 BC. This book is a
            treatise on the theory of ethics, very popular during the
            Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit
            amet..", comes from a line in section 1.10.32. The standard chunk of
            Lorem Ipsum used since the 1500s is reproduced below for those
            interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et
            Malorum" by Cicero are also reproduced in their exact original form,
            accompanied by English versions from the 1914 translation by H.
            Rackham. Where can I get some? There are many variations of passages
            of Lorem Ipsum available, but the majority have suffered alteration
            in some form, by injected humour, or randomised words which don't
            look even slightly believable. If you are going to use a passage of
            Lorem Ipsum, you need to be sure there isn't anything embarrassing
            hidden in the middle of text. All the Lorem Ipsum generators on the
            Internet tend to repeat predefined chunks as necessary, making this
            the first true generator on the Internet. It uses a dictionary of
            over 200 Latin words, combined with a handful of model sentence
            structures, to generate Lorem Ipsum which looks reasonable. The
            generated Lorem Ipsum is therefore always free from repetition,
            injected humour, or non-characteristic words etc.
          </Style.TextContainer>
          <Style.DateContainer>
            25.05.2022 / 25.07.2022 (Expirat)
          </Style.DateContainer>
        </Style.DescriptionContainer>
        <Style.PhotosContainer>
          <Style.BigPhotoContainer>
            {handleMedia("photo", photo, "820", "279")}
          </Style.BigPhotoContainer>
          <Style.SmallPhotosContainer>
            {handleMedia("photo", photo, "190", "142")}
            {handleMedia("photo", photo, "190", "142")}
            {handleMedia("photo", photo, "190", "142")}
            {handleMedia("photo", photo, "190", "142")}
          </Style.SmallPhotosContainer>
        </Style.PhotosContainer>
      </Style.ContentContainer>
    </Style.Container>
  );
};

export default EventDetails;
